import { Link } from '@tanstack/react-router';
import { Card, CardFooter } from 'src/shared/components/ui/card';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

export default function NoAccess() {
  const { logout } = useAuth();
  return (
    <div className="flex h-screen justify-center items-center grid-container">
      <div>
        <img src="/static/images/tekst-logo.svg" width={80} height={20} className="mx-auto mb-4" alt="Tekst logo" />
        <Card className="w-[400px] px-7 pt-6 pb-2 space-y-6">
          <div className=" w-full text-center">
            <p className="text-neutral-400">Access Denied</p>
          </div>
          <div className="text-center text-neutral-950">
            <p className="text-neutral-500 text-sm">
              Insufficient rights - Please contact your organization administrator if you would like access.
            </p>
          </div>
          <CardFooter className="flex-center pb-0">
            <div>
              <Link to="/login" onClick={logout} className="mt-5 flex-center text-neutral-400 text-xs hover:underline">
                Back to login
              </Link>
            </div>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
